module.exports = __webpack_public_path__ + "static/media/house_lime.ce3dd233.csv";